import { useState, useEffect } from 'react';
import createClient, { AuthClient } from '../../graphql/client';
import getConfig from '../../config';

export default function useApolloClient() {
  const [loading, setLoading] = useState<boolean>(true);
  const [client, setClient] = useState<AuthClient>();
  const [error, setError] = useState<Error>();

  useEffect(() => {
    async function getClient() {
      const config = getConfig();
      try {
        const queryParameters = new URLSearchParams(window.location.search);
        const returnTo = queryParameters.get('returnTo');
        if (returnTo) {
          localStorage.setItem('returnTo', returnTo.toString());
        }

        const closeWindowOnCompletion = queryParameters.get('closeWindowOnCompletion');
        if (closeWindowOnCompletion) {
          localStorage.setItem('closeWindowOnCompletion', closeWindowOnCompletion.toString());
        }

        const client = await createClient(config.apiUrl, config.ssoUrl);
        setClient(client);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }
    getClient().catch((err) => console.log(err));
  }, [setClient, setError, setLoading]);

  return { loading, client, error };
}
